import React from "react";
import { Modal, Input, message } from "antd";
import { modalTitle } from "../../../components";

interface CartDraftNamingModalProps {
  open: boolean;
  onCancel: () => void;
  draftName: string;
  setDraftName: (name: string) => void;
  onOk: () => void;
}

export const CartDraftNamingModal: React.FC<CartDraftNamingModalProps> = ({
  open,
  onCancel,
  draftName,
  setDraftName,
  onOk,
}) => {
  const handleConfirm = () => {
    if (!draftName.trim()) {
      message.warning("Please enter a name for the draft.");
      return;
    }
    onOk();
  };

  return (
    <Modal
      title={modalTitle("Name Your Draft Cart")}
      open={open}
      onCancel={onCancel}
      onOk={handleConfirm}
      okText="Save Draft"
      okButtonProps={{ size: "middle" }}
      cancelButtonProps={{ size: "middle" }}
    >
      <div className="py-4">
        <label className="block text-xs font-semibold text-gray-500 mb-2 uppercase tracking-wide">
          Draft Name / Label
        </label>
        <Input
          placeholder="e.g. John's Order, Table 4 VIP"
          value={draftName}
          onChange={(e) => setDraftName(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleConfirm();
            }
          }}
          maxLength={100}
          size="middle"
        />
        <p className="text-[10px] text-gray-400 mt-2">
          Adding a descriptive name makes it easy to identify and restore this
          draft later.
        </p>
      </div>
    </Modal>
  );
};
